class measureDistance{
  constructor(){
    this._handler = null
    this._map = null
  }
}

measureDistance.prototype.measure = async function (handler, map) {
  this._handler = handler
  this._map = map

  // 地形采样
  const terrainProvider = await Cesium.createWorldTerrainAsync();

  const that = this
  let activePositions = [] // point/coordinates collections of mouse pick
  let floatingPoint // points(start or end of line) show in map
  let activeShape // lines show in map
  let labelPt // label show in map for specific distance
  handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
  handler.setInputAction(function (event) {        
    const ray = map.viewer.camera.getPickRay(event.position)
    const earthPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
    // if mouse is not over the globe, earthPosition will be undefined
    if(Cesium.defined(earthPosition)){
      if(activePositions.length === 0){
        floatingPoint = that.createPoint(earthPosition)
        activePositions.push(earthPosition) // current point push in 
        //dynamic drawing : false represents the value will change, and this value will be returned every time
        const dynamicPositions = new Cesium.CallbackProperty(function (params) {
          return activePositions;
        },false)
        activeShape = that.drawLine(dynamicPositions)
      }

      // 标签的位置，具体绘制在getSpaceDistance
      labelPt = activePositions[activePositions.length - 1]
      if(activePositions.length >= 2){
        that.getSpaceDistance(activePositions,terrainProvider,labelPt,floatingPoint,map.viewer)
      }
      
      activePositions.push(earthPosition)
      that.createPoint(earthPosition)
    }    
  },Cesium.ScreenSpaceEventType.LEFT_CLICK)

  handler.setInputAction(function (event) {
    if(Cesium.defined(floatingPoint)){
      const ray = map.viewer.camera.getPickRay(event.endPosition)
      const newPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
      if(Cesium.defined(newPosition)){
        floatingPoint.position.setValue(newPosition)
        activePositions.pop()
        activePositions.push(newPosition)
      }
    }
  },Cesium.ScreenSpaceEventType.MOUSE_MOVE)

  handler.setInputAction(function (event) {
    activePositions.pop() // the last point pop
    that.drawLine(activePositions)
    map.viewer.entities.remove(floatingPoint) //point
    map.viewer.entities.remove(activeShape) //line
    floatingPoint = undefined
    activeShape = undefined
    activePositions = []
  },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
}
//创建点实体
measureDistance.prototype.createPoint = function(position){
  const points = this._map.viewer.entities.add({
    position:position,
    point:{
      color:Cesium.Color.ORANGE,
      pixelSize:5,
      // heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
    }
  })
  return points
}

//根据点去绘制线
measureDistance.prototype.drawLine = function(positions){
  let shape 
  shape = this._map.viewer.entities.add({
    polyline:{
      positions:positions,
      clampToGround:false,
      width:3
    }
  })
  return shape
}

//计算两点间的距离
measureDistance.prototype.getSpaceDistance = async function(positions,terrainProvider,labelPt,floatingPoint,viewer){
  let distance = 0
  var i = positions.length - 2
  var point1Cartographic = Cesium.Cartographic.fromCartesian(positions[i])
  var point2Cartographic = Cesium.Cartographic.fromCartesian(positions[i+1])

  var geodesic = new Cesium.EllipsoidGeodesic()
  geodesic.setEndPoints(point1Cartographic,point2Cartographic)

  var s = geodesic.surfaceDistance; //get distance from the start to the end
  var cartoPts = [point1Cartographic]
  //这里的分段采样可以换成线性插值lerp
  for(var jj = 100;jj<s;jj+=100){//分段采样计算距离
    var cartoPt = geodesic.interpolateUsingSurfaceDistance(jj) //求地表连线上特定距离的点的坐标
    cartoPts.push(cartoPt)
  }
  cartoPts.push(point2Cartographic)
  //带有地形高度的点
  const updatedPositions = await Cesium.sampleTerrain(viewer.terrainProvider, 8, cartoPts);
  console.log(updatedPositions);
  for(var ii = 0;ii<updatedPositions.length - 1;ii++){
    var geoD = new Cesium.EllipsoidGeodesic()
    geoD.setEndPoints(updatedPositions[ii],updatedPositions[ii+1])
    var innderS = geoD.surfaceDistance;
    console.log(innderS);
    innderS = Math.sqrt(Math.pow(innderS,2)+Math.pow(updatedPositions[ii+1].height-updatedPositions[ii].height,2)) //计算贴地距离（带地形的）
    console.log(innderS);
    distance += innderS
  }

  if(distance != 0){
    let textDistance = distance.toFixed(2) + 'm'
    console.log(distance.toFixed(2));
    if(textDistance >= 1000){
      textDistance = (distance / 1000.0).toFixed(2) + 'km'
    }
    floatingPoint = viewer.entities.add({
      name:'贴地距离',
      position:labelPt,
      point:{
        pixelSize:5,
        color:Cesium.Color.RED,
        outlineColor:Cesium.Color.WHITE,
        outlineWidth:2
      },
      label:{
        text:textDistance,
        font:'18px sans-serif',
        fillColor:Cesium.Color.GOLD,
        style:Cesium.LabelStyle.FILL_AND_OUTLINE,
        outlineWidth:2,
        verticalOrigin:Cesium.VerticalOrigin.BOTTOM,
        pixelOffset:new Cesium.Cartesian2(20,-20)
      }
    }) 
  }
}

export default measureDistance


